var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dec_digital_flop"},[(_vm.title)?_c('span',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('dv-digital-flop',{style:(_vm.styles),attrs:{"config":_vm.mergerConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }